/**
 * @author SwathiDivya Bhavaraju
 * @email [example@mail.com]
 * @create date 2022-06-09 15:04:07
 * @modify date 2022-06-09 15:04:07
 * @desc [description]
 */
import axios from 'axios';

/**
 * /producttracker/metadata get API
* to get the classifications/directive/status list */
export async function getProductTrackerMetaData() {
  let metadata = {};
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/metadata`)
    .then((response) => {
      metadata = response.data.data;
    })
    .catch((err) => {
      console.log('producttracker/metadata get java api error', err); // eslint-disable-line no-console
    });
  return metadata;
}
/**
 * /producttracker/id get API
* to get the prpduct tracker details by id */
export async function getProductTrackerById(id) {
  let metadata = {};
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/${id}`)
    .then((response) => {
      metadata = response.data.data;
    })
    .catch((err) => {
      console.log('producttracker/id get java api error', err); // eslint-disable-line no-console
    });
  return metadata;
}

/**
 * /producttracker/id get API
* to get the prpduct tracker details by id */
export async function getProductTrackerByCountryId(id, countryId) {
  let metadata = {};
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/${id}/${countryId}`)
    .then((response) => {
      metadata = response.data.data;
    })
    .catch((err) => {
      console.log('producttracker/id/countryId get java api error', err); // eslint-disable-line no-console
    });
  return metadata;
}

/**
 * /producttracker post API
* to add the product tracker */
export async function postProductTracker(data) {
  let result;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/producttracker`, data)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('producttracker post java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * /producttracker put API
* to update the product tracker */
export async function updateProductTracker(data, id) {
  let result;
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/${id}`, data)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('producttracker post java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * /producttracker put API
* to update the product tracker */
export async function updateProductTrackerByCountryId(data, id, countryId) {
  let result;
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/${id}/${countryId}`, data)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('producttracker post java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * /producttracker/content post API
* to get the product tracker based on filter */
export async function getProductsListByAccountId(data) {
  let metadata = {};
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/content`, data)
    .then((response) => {
      metadata = response.data.data;
    })
    .catch((err) => {
      console.log('/producttracker/content get java api error', err); // eslint-disable-line no-console
    });
  return metadata;
}

/**
 * /producttracker post API
* to add the product tracker */
export async function updateProductStatus(id, countryId, workflowStatusId) {
  let res = null;
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/market/${id}/${countryId}/${workflowStatusId}`)
    .then((response) => {
      res = response.data;
    })
    .catch((err) => {
      console.log('/producttracker/market/status put java api error', err); // eslint-disable-line no-console
    });
  return res;
}

/**
 * /producttracker/market/remove delete API
* to remove the products */
export async function removeProducts(data) {
  let res = null;
  await axios
    .delete(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/market/remove`, { data })
    .then((response) => {
      res = response.data;
    })
    .catch((err) => {
      console.log('/producttracker/market/remove delete java api error', err); // eslint-disable-line no-console
    });
  return res;
}
/**
* /producttracker/market/remove/request post API
* to request the removal of the product by PM */
export async function removeProductRequestByPM(data) {
  let res = null;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/market/remove/request`, data)
    .then((response) => {
      res = response.data;
    })
    .catch((err) => {
      console.log(' /producttracker/market/remove/request post java api error', err); // eslint-disable-line no-console
    });
  return res;
}

/**
 * /producttracker/market/delegate/remove post API
* to request the removal of the products */
export async function requestProductRemoval(data) {
  let res = null;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/market/delegate/remove`, data)
    .then((response) => {
      res = response.data;
    })
    .catch((err) => {
      console.log('/producttracker/market/delegate/remove post java api error', err); // eslint-disable-line no-console
    });
  return res;
}

/**
 * /producttracker/market/delegate/remove post API
* to request the modifications of the products */
export async function requestProductModification(data) {
  let res = null;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/market/delegate/update`, data)
    .then((response) => {
      res = response.data;
    })
    .catch((err) => {
      console.log('/producttracker/market/delegate/update post java api error', err); // eslint-disable-line no-console
    });
  return res;
}

/**
 * /producttracker/info/{id} get API
* to get the product tracker status info based on market and id */
export async function getProductTrackerInfoById(prodTrckrId, countryId) {
  let metadata = {};
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/info/${prodTrckrId}/${countryId}`)
    .then((response) => {
      metadata = response.data.data;
    })
    .catch((err) => {
      console.log('/producttracker/info/{id} get java api error', err); // eslint-disable-line no-console
    });
  return metadata;
}
/**
 * /producttracker/info/contact get API
* to get the product tracker status info based on market and id */
export async function getProductTrackerContactsInfoById(prodTrckrId, countryId) {
  let metadata = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/info/contact/${prodTrckrId}/${countryId}`)
    .then((response) => {
      metadata = response.data.data;
    })
    .catch((err) => {
      console.log('/producttracker/info/contact get java api error', err); // eslint-disable-line no-console
    });
  return metadata;
}
/**
 * /producttracker/market/contact put API
* to get the product tracker status info based on market and id */
export async function updateProductTrackerContactsById(prodTrckrId, countryId, data) {
  let metadata = {};
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/market/contact/${prodTrckrId}/${countryId}`, data)
    .then((response) => {
      metadata = response.data;
    })
    .catch((err) => {
      console.log('/producttracker/market/contact put java api error', err); // eslint-disable-line no-console
    });
  return metadata;
}

/**
 * /producttracker/market/process/remove/request post API
* to approve/deny the removal of the products */
export async function approveProductRemoval(data) {
  let res = null;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/market/process/remove/request`, data)
    .then((response) => {
      res = response.data;
    })
    .catch((err) => {
      console.log('/producttracker/market/process/remove/request post java api error', err); // eslint-disable-line no-console
    });
  return res;
}

/**
 * /producttracker/market/{prodTrckrId}/{countryId} get API
* to get the status information of the product */
export async function getProductRemovalStatus(prodTrckrId, countryId) {
  let res = null;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/producttracker/market/${prodTrckrId}/${countryId}`)
    .then((response) => {
      res = response.data;
    })
    .catch((err) => {
      console.log('/producttracker/market/{prodTrckrId}/{countryId} get java api error', err); // eslint-disable-line no-console
    });
  return res;
}
